const getCookie = (name) => {
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
};


const deleteCookie = (name, path) => {
    if (getCookie(name)) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + path + ";";
    }
};



const cookieName = 'foxy_show_go_back_link';
const signinRedirect = getCookie(cookieName);


document.addEventListener("DOMContentLoaded", async () => {
    const loginStatus = document.getElementById("foxy-login-status");
    if (!loginStatus) {
        return;
    }

    const response = await fetch(
        window.wpajax.ajaxurl,
        {
            method: "POST",
            body: new URLSearchParams({
                action: "foxy_cart_login_status"
            })
        }
    );
    if (!response.ok) {
        loginStatus.remove();
        return;
    }
    loginStatus.innerHTML = await response.text();
    const logOutButton = document.getElementById("foxy-cart-logout");
    const customerCookie = 'fx.customer';
    const jwtCookie = 'fx.customer.jwt';
    const ssoCookie = 'fx.customer.sso';

    if (logOutButton) {
        logOutButton.addEventListener("click", (e) => {
            if (!customerCookie && !jwtCookie) {
                return;
            }
            e.preventDefault();
            deleteCookie(customerCookie, "/");
            deleteCookie(jwtCookie, "/");
            deleteCookie(ssoCookie, "/");
            window.location = e.target.href;
        });
    }

}); 